export default __webpack_public_path__ + "static/media/Brewbound-Logo.bcf4a13e.svg";